var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-uploader"},[_vm._t("default",function(){return [_c('j-button',{attrs:{"label":"Add Images","icon":"image","block":""},on:{"action":_vm.handleUpload}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }